// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__i-Ht3","transparent":"Button_transparent__2Jo7g"};